import { useId } from "react";

export interface BrandMarkProps {
  size?: number;
  className?: string;
  title?: string;
}

/**
 * Temporary original wordmark glyph: three connected weave cells. Simple and
 * code-native so it can be edited freely until the final brand-asset pass.
 */
export function BrandMark({ size = 26, className, title }: BrandMarkProps) {
  const gradientId = useId();

  return (
    <svg
      width={size}
      height={size * 0.62}
      viewBox="0 0 42 26"
      className={className}
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0.4">
          <stop offset="0%" stopColor="var(--accent-cyan)" />
          <stop offset="55%" stopColor="var(--accent-blue)" />
          <stop offset="100%" stopColor="var(--accent-violet)" />
        </linearGradient>
      </defs>
      <g fill="none" stroke={`url(#${gradientId})`} strokeWidth="2" strokeLinejoin="round">
        <path d="M9 4 L17 13 L9 22 L1 13 Z" />
        <path d="M21 4 L29 13 L21 22 L13 13 Z" />
        <path d="M33 4 L41 13 L33 22 L25 13 Z" />
      </g>
    </svg>
  );
}
